
import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Form, InputGroup, Pagination } from 'react-bootstrap';
import { BiMessageSquareDetail } from "react-icons/bi";
import { AiOutlineFilePdf } from "react-icons/ai";
import { IoIosCheckmark } from "react-icons/io";
import config from "../../config/config";
import Loader from "../loader/Loader";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from 'react-toastify';
export default function UnderInspection() {
  const [loading, setLoading] = useState(false);
  const [underinspection, setUnderinspection] = useState([]);
  const [failedinspection, setFailedinspection] = useState([]);
  const [files, setFiles] = useState({});
  const fileInputRefs = useRef({});
  const [currentPageUnder, setCurrentPageUnder] = useState(1);
  const [currentPageFail, setCurrentPageFail] = useState(1);
  const itemsPerPage = 10;
  const paginate = (data, page) => {
    const start = (page - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  };
  const underData = paginate(underinspection, currentPageUnder);
  const failData = paginate(failedinspection, currentPageFail);
  const totalUnderPages = Math.ceil(underinspection.length / itemsPerPage);
  const totalFailPages = Math.ceil(failedinspection.length / itemsPerPage);
  const fetchUnderinspection = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/inspection/underinspection`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data?.success) {
        setUnderinspection(response.data.unit_completed || []);
        setCurrentPageUnder(1);
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchFailedinspection = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/inspection/failedinspection`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data?.success) {
        setFailedinspection(response.data.unit_completed || []);
        setCurrentPageFail(1);
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUnderinspection();
    fetchFailedinspection();
  }, []);
  const handleFileChange = (id, e) => {
    if (e.target.files?.[0]) {
      setFiles(prev => ({ ...prev, [id]: e.target.files[0] }));
    }
  };
  const handleSubmit = async (id, status) => {
    const token = getAuthToken();
    if (!token) return toast.error("Token missing");
    if (!files[id]) return toast.warn("Please select a file");
    try {
      const formData = new FormData();
      formData.append("file", files[id]);
      formData.append("status", status);
      const res = await axios.post(
        `${config.API}/inspection/underinspectionfile/${id}`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data?.success) {
        toast.success(res.data.message);
        setFiles(prev => ({ ...prev, [id]: null }));
        if (fileInputRefs.current[id]) fileInputRefs.current[id].value = "";
        fetchUnderinspection();
        fetchFailedinspection();
      } else {
        toast.error(res.data?.message);
      }
    } catch {
      toast.error("Submission failed");
    }
  };
  const renderPagination = (totalPages, currentPage, setPage) => (
    totalPages > 1 && (
      <Pagination className="justify-content-end mt-3">
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => setPage(currentPage - 1)}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i}
            active={i + 1 === currentPage}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => setPage(currentPage + 1)}
        />
      </Pagination>
    )
  );
  return (
    <div className="container-fluid my-4">
      <div className="card shadow-sm">
        <div className="card-body">
          <Table responsive className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Product ID</th>
                <th>PO Number</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Inspection Date</th>
                <th>Inspector</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="7" className="text-center"><Loader /></td></tr>
              ) : underData.length ? (
                underData.map(under => (
                  <tr key={under.id}>
                    <td>{under?.product?.product_code}</td>
                    <td>{under?.purchase_order?.po_number}</td>
                    <td>{under.product?.name}</td>
                    <td>{under.actual_quantity}</td>
                    <td>{under?.purchase_order?.inspection_date}</td>
                    <td>{under.inspector}</td>
                    <td>
                      <InputGroup className="mb-2">
                        <Form.Control
                          type="file"
                          accept="application/pdf"
                          ref={el => (fileInputRefs.current[under.id] = el)}
                          onChange={e => handleFileChange(under.id, e)}
                        />
                        <AiOutlineFilePdf className="ms-2 mt-2 fs-4" />
                      </InputGroup>
                      <div className="d-flex gap-2">
                        <Button size="sm" variant="success"
                          onClick={() => handleSubmit(under.id, 1)}>
                          <IoIosCheckmark /> Pass
                        </Button>
                        <Button size="sm" variant="danger"
                          onClick={() => handleSubmit(under.id, 0)}>
                          <BiMessageSquareDetail /> Fail
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="7" className="text-center text-muted">No data found</td></tr>
              )}
            </tbody>
          </Table>
          {renderPagination(totalUnderPages, currentPageUnder, setCurrentPageUnder)}
        </div>
      </div>
      <h4 className="mt-4">Under Inspection Fail List</h4>
      <div className="card shadow-sm">
        <div className="card-body">
          <Table responsive className="align-middle">
            <thead className="table-light">
              <tr>
                <th>Product ID</th>
                <th>PO Number</th>
                <th>Product Name</th>
                <th>Quantity</th>
                <th>Inspection Date</th>
                <th>Inspector</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="6" className="text-center"><Loader /></td></tr>
              ) : failData.length ? (
                failData.map(failed => (
                  <tr key={failed.id}>
                    <td>{failed.product?.product_code}</td>
                    <td>{failed?.purchase_order?.po_number}</td>
                    <td>{failed.product?.name}</td>
                    <td>{failed.actual_quantity}</td>
                    <td>{failed?.purchase_order?.inspection_date}</td>
                    <td>{failed.inspector}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="6" className="text-center text-muted">No data found</td></tr>
              )}
            </tbody>
          </Table>
          {renderPagination(totalFailPages, currentPageFail, setCurrentPageFail)}
        </div>
      </div>
    </div>
  );
}
